module.exports = __webpack_public_path__ + "static/background-big-8de968890ab061275d9cd3a632ba9485.png";